var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c("div", { staticClass: "date col-2" }, [
          _c("p", { staticClass: "mb-0 date-text" }, [
            _c("i", { staticClass: "fa fa-circle date-circle " }),
            _vm._v("\n        " + _vm._s(_vm.logGroup.date) + "\n      ")
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.logGroup.logs, function(log) {
        return _c("logs-item", { key: log.id, attrs: { log: log } })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee8becb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee8becb0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/LogsGroup.vue
// module id = null
// module chunks = 